module.exports = __webpack_public_path__ + "static/media/icon-shorthaul.1.8d06dfda.svg";